import Highlights from "./content/highlights";
import PageFunctionality from "./content/page-functionality";
import Terminology from "./content/terminology";
import SupportedBrowsers from "./content/supported-browsers";
import ResponsibleGaming from "./content/responsible-gaming";
import TitleBar from "./title-bar";
import Header from "components/header";
import topLevelStyles from "./top-level-styles.module.css";
import Accordion from "react-bootstrap/Accordion";
import AccordionHeader from "./accordion/accordion-header";
import { useAppSelector } from "state/hooks";
import { getGroupState, getGroupStyles } from "state/slices/group-slice";
import OpenSansText from "components/custom-texts/open-sans-text";
import LoginButtons from "components/login-buttons";

const SECTIONS = [
  { title: "Highlights", content: Highlights },
  { title: "Page Functionality", content: PageFunctionality },
  { title: "Terminology", content: Terminology },
  { title: "Supported Browsers", content: SupportedBrowsers },
  { title: "Responsible Gaming", content: ResponsibleGaming },
  {
    title: "Contact",
    content: () => (
      <div>
        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
          <OpenSansText>
            Questions? Contact us at support@betsparket.com and mention which group or app you are playing on. You may also contact us via our phone support lines, 9am-5pm PT US, Monday through Friday, at +1 (424) 329-6296
          </OpenSansText>
        </div>
      </div>
    ),
  },
];

const Help = () => {
  const primaryColor = useAppSelector(getGroupStyles).primary_color;
  const includeContact = useAppSelector(getGroupState).customization.contact;

  const filteredSections = includeContact
    ? SECTIONS
    : SECTIONS.filter((section) => section.title !== "Contact");

  return (
    <>
      <Header />
      <LoginButtons />
      <TitleBar />
      <Accordion>
        {filteredSections.map((section, index) => {
          const Content = section.content;
          return (
            <div key={index}>
              <AccordionHeader
                eventKey={index.toString()}
                backgroundColor={primaryColor}
                styles={topLevelStyles}
              >
                {section.title}
              </AccordionHeader>
              <Accordion.Collapse eventKey={index.toString()}>
                <Content />
              </Accordion.Collapse>
            </div>
          );
        })}
      </Accordion>
    </>
  );
};

export default Help;
